function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "trashcan");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "iPhone-XS-Copy-6",
  transform: "translate(-205.000000, -310.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M206.285714,330.571429 C206.285714,331.985714 207.442857,333.142857 208.857143,333.142857 L219.142857,333.142857 C220.557143,333.142857 221.714286,331.985714 221.714286,330.571429 L221.714286,315.142857 L206.285714,315.142857 L206.285714,330.571429 Z M223,311.285714 L218.5,311.285714 L217.214286,310 L210.785714,310 L209.5,311.285714 L205,311.285714 L205,313.857143 L223,313.857143 L223,311.285714 Z",
  id: "trashcan"
})));

var SvgTrashcan = function SvgTrashcan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "24px",
    viewBox: "0 0 18 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrashcan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trashcan.6475cb2c.svg";
export { ForwardRef as ReactComponent };